<template>
  <div class="search-result">
    <div
      class="search-result__heading"
      :class="{
        'search-result__heading--exists':
          result.action === FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT,
        'search-result__heading--with-owner':
          result.action === FACILITY_CREATE_ACTION.WITH_OWNER,
        'search-result__heading--without-owner':
          result.action === FACILITY_CREATE_ACTION.WITHOUT_OWNER
      }"
    >
      <span class="mr-3">
        {{ $t(`message.facilityCreate.dialog.inGoogle.${result.action}.text`) }}
      </span>
      <v-tooltip top :max-width="533">
        <template v-slot:activator="{ on }">
          <div class="info-icon" v-on="on">
            <v-icon size="17" color="lime">mdi-information</v-icon>
          </div>
        </template>
        <span>
          {{
            $t(
              `message.facilityCreate.dialog.inGoogle.${result.action}.tooltip`
            )
          }}
        </span>
      </v-tooltip>
    </div>
    <div class="search-result__radio" @click="select">
      <v-btn class="mr-2" icon color="primary" @click="select">
        <v-icon>
          {{ selected ? "icon-radio-on" : "icon-radio-off" }}
        </v-icon>
      </v-btn>
      <div class="search-result__facility-data">
        <p class="mb-0">
          {{ result.name }}
        </p>
        <p class="mb-0">
          {{ result.formatted_address }}
        </p>
      </div>
      <a
        v-if="actionUrl"
        class="search-result__goto-btn"
        :href="actionUrl"
        target="_blank"
      >
        {{ $t(`message.facilityCreate.dialog.inGoogle.${result.action}.goTo`) }}
      </a>
    </div>
  </div>
</template>

<script>
import { FACILITY_CREATE_ACTION } from "@/enums/gmb-search-type";

export default {
  name: "SingleSearchResult",
  props: {
    result: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      FACILITY_CREATE_ACTION
    };
  },
  computed: {
    actionUrl() {
      if (this.result) {
        if (this.result.exists_in_account && this.result.gmb_profile_url) {
          return this.result.gmb_profile_url;
        } else {
          return this.result.google_maps_url;
        }
      }
      return null;
    }
  },
  methods: {
    select() {
      this.$emit("select", { ...this.result });
    }
  }
};
</script>

<style lang="scss" scoped>
.search-result {
  display: flex;
  flex-direction: column;
  padding: $spacing 0;

  &__description {
    margin: $spacing 0;
    padding: $spacing 0;

    &--top {
      border-bottom: 1px solid $light-3;
    }

    &--bottom {
      border-top: 1px solid $light-3;
    }
  }

  &__heading {
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 30px;
    padding: $spacing $spacing * 4;

    color: $text;
    font-weight: 500;
    margin-bottom: $spacing;

    &--exists {
      border-color: $cyan;
    }

    &--with-owner {
      border-color: $pink;
    }

    &--without-owner {
      border-color: $lime;
    }
  }

  &__radio {
    display: flex;
    align-items: center;
    cursor: pointer;
    background: transparent;
    border-radius: 4px;
    padding: 0 $spacing;

    &:hover {
      background: rgba($text, 0.1);
    }
  }

  &__facility-data {
    display: flex;
    flex-direction: column;

    p {
      margin-bottom: 0;
      color: $text;

      &:first-child {
        @include font-size(14px);
        line-height: 16px;
        padding-top: $spacing * 0.5;
        font-weight: 500;
      }
      &:last-child {
        @include font-size(12px);
      }
    }
  }

  &__goto-btn {
    display: block;
    margin-left: auto;
    @include font-size(14px);
    color: $primary;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
    transition: 0.1s background ease-in-out;
    padding: $spacing * 0.5 $spacing;
    background: transparent;
    border-radius: 4px;

    &:hover {
      background: rgba($primary, 0.1);
    }
  }
}
</style>
